'use client';

import React from 'react';
import ConnectionsContent from './components/ConnectionsContent';

export default function ConnectionsPage() {
  return <ConnectionsContent />;
}
